import GeoChart from "../../components/GeoChart";
import Header from "../../components/Header";
import { Box, useTheme } from "@mui/material";
import { tokens } from "../../theme";

const Index = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box m="20px" sx={{ marginTop: "100px" }}>
      <Header title="Geo Chart" subtitle="Simple Geo Chart" />
      <Box
        height={"75vh"}
        border={`1px solid ${colors.grey[100]}`}
        borderRadius="4px"
      >
        <GeoChart data={[]} />
      </Box>
    </Box>
  );
};

export default Index;
